import {Plugin} from '@oracle/ortl-core';

/**
 * Stops propagation of ENTER keypress event out of editor
 *
 * @extends module:core/plugin~Plugin
 */
export default class HandleEnter extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'HandleEnter';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [];
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const view = this.editor.ui.view;
		view.on('render', () => {
			view.element.addEventListener('keypress', (evt) => {
				if (evt.keyCode === 13) {
					evt.stopPropagation();
				}
			});
		});
	}
}
